import SkTechApiClient from "./base/SkTechApiClient";
import { ProjectDocumentFolder } from "../stores/ProjectDocumentationFolderStore";

export default class ProjectDocumentsFoldersApiClient extends SkTechApiClient {
    public getByProjectId = async (id: string): Promise<any> => {
        return await this.Get(`/api/DocumentationFolder/ByProject?projectId=${id}`).then(
            function (response) {
                if (response.status === 200) {
                    return response.data;
                }
                return false;
            }
        );
    };

    public add = async (document: ProjectDocumentFolder): Promise<any> => {
        return await this.Post(`/api/DocumentationFolder/AddDocumentFolder`, {
            projectId: document.projectId,
            name: document.name,
            parentFolderId: document.parentFolderId,
            orderIndex: document.orderIndex,
            deleteStatus: document.deleteStatus,
            isRoot: document.isRoot,
        }).then(function (response) {
            if (response.status === 200 || response.status === 201) {
                return response.data;
            }
            return false;
        });
    };

    public updateName = async (folderId: string, newName: string): Promise<any> => {
        return await this.Patch(`/api/DocumentationFolder/UpdateName/${folderId}`, {
            name: newName 
        }).then(function (response) {
            if (response.status === 200) {
                return response.data;
            }
            return false;
        });
    };

    public updatePosition = async (folderId: string, parentFolderId: string | null, orderIndex: number | string): Promise<any> => {
        return await this.Patch(`/api/DocumentationFolder/UpdateFolderPosition/${folderId}`, {
            parentFolderId,
            orderIndex: String(orderIndex),
        }).then(function (response) {
            if (response.status === 200) return response.data;
            return false;
        });
    };

    public deleteById = async (folderId: string | number): Promise<any> => {
        return await this.Delete(`/api/DocumentationFolder/DeleteDocumentFolder/${folderId}`).then(
            function (response) {
                if (response.status === 200) {
                    return response.data;
                }
                return false;
            }
        );
    };
}
